import React, { useState } from 'react';
import YesNo from '../Components/YesNo';
import Alert from '../../Alert';
import useTranslation from '../../../Hooks/useTranslation';

const useComponent = () => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(-1);

  function Component({ index, optionEvents }) {
    switch (index) {
      case 0:
        return (
          <div>
            <YesNo
              title={t('Login.LogoutModalTitle')}
              question={t('Login.LogoutModalQuestion')}
              cancelText={t('Dialog.CancelText')}
              acceptText={t('Dialog.AcceptText')}
              cancel={() => {
                setOpenModal(!openModal);
              }}
              accept={() => {
                optionEvents[index](setError, setErrorMessage);
                setOpenModal(!openModal);
                setOpenAlert(true);
              }}
              open={openModal}
              setOpen={setOpenModal}
            />
            <Alert
              message={error ? errorMessage : t('Login.LogoutSuccessful')}
              open={openAlert}
              setOpen={setOpenAlert}
              error={error}
            />
          </div>
        );
      default:
        return <div />;
    }
  }

  return {
    Component,
    openModal,
    setOpenModal,
    openAlert,
    setOpenAlert,
    setSelectedIndex,
    selectedIndex,
  };
};

export default useComponent;
